<template>
  <div class="my-ai-teacher-container">
    <CustomTitleBar @back="handleback" />
    <div class="ai-teacher-edit" v-if="isTeacherEditVisible">
      <ai-teacher-page
        :type="type"
        :config="aiTeacherConfig"
        :cur="curAiSelectTeacherProfile"
        :aiParams="aiParams"
        @input="handleAiTeacherName"
        @select="handleAiTeacherSelect"
        @cancel="handleAiTeacherCancel"
        @submit="handleAiTeacherSubmit"
        @delete="handleAiTeacherDelete"
      />
    </div>
    <div class="ai-teacher-info" :class="[showTitleBar ? 'hasbar' : '']" v-else>
      <div class="setting" @click="handleSettingClick">
        <img src="./assets/icon_setting_btn@2x.png" />
      </div>
      <div class="info">
        <div class="ava">
          <img :src="infoHeadImg" />
        </div>
        <div class="name">
          {{ infoName }}
        </div>
      </div>
      <div class="carousel">
        <Carousel />
      </div>
    </div>
    <CloseTipPopup :visible="isCloseTipVisible" @submit="handleDelConfirmSubmit" @close="isCloseTipVisible = false" />
  </div>
</template>

<script lang="ts">
import { Component, AiTeacherPage, Prop, AiTeacherAudioPlayer, BaseComponent } from 'kuaidong-component'
import { KdButton, KdLayoutFixedBottomButton } from 'kuaidong-ui'
import { getAiTeacherConfig, getAiTeacherInfo, switchAiTeacher } from 'kuaidong-api'
import { IAiTeacherConfig, IAiTeacherInfo, IAiTeacherProfile } from 'kuaidong-model'
import { systemStore, teacherStore } from 'kuaidong-store'
import { AppUtil } from 'kuaidong-lib'
import CloseTipPopup from './CloseTipPopup.vue'
import Carousel from './Carousel.vue'
import CustomTitleBar from './CustomTitleBar.vue'
import { TitleBar } from 'kuaidong-service'

@Component({
  components: {
    KdButton,
    KdLayoutFixedBottomButton,
    AiTeacherPage,
    CloseTipPopup,
    Carousel,
    CustomTitleBar,
  },
})
export default class AiTeacherEditPage extends BaseComponent {
  @Prop({ type: String, default: '' })
  type!: 'add' | 'edit'

  isTeacherEditVisible = false
  aiTeacherConfig: IAiTeacherConfig | null = null
  curAiSelectTeacherProfile: IAiTeacherProfile | null = null
  aiTeacherInfo: IAiTeacherInfo | null = null
  aiTeacherAudioPlayer: AiTeacherAudioPlayer | null = null
  selectAiTeacherProfile: IAiTeacherProfile | null = null
  aiParams = {
    curAiTeacherVoiceText: '',
    curAiInputTeacherName: '',
  }
  // type = 'edit'
  isUnderApp = false
  isCloseTipVisible = false
  async mounted() {
    await this.fetch()
    systemStore.hideTitleBar()
    if (this.type === 'add') {
      this.isTeacherEditVisible = true
    }
  }
  beforeDestroy() {
    this.aiTeacherAudioPlayer?.pause()
    // TitleBar.init()
    // systemStore.initTitleBarVisible()
  }
  get infoHeadImg() {
    return this.curAiSelectTeacherProfile?.pic || ''
  }
  get showTitleBar() {
    return systemStore.titleBarVisible
  }

  get infoName() {
    return this.aiTeacherInfo?.name || ''
  }
  async fetchAiTeacherInfo() {
    try {
      const aiTeacherInfo = await getAiTeacherInfo()
      this.aiTeacherInfo = aiTeacherInfo?.image_id && aiTeacherInfo.is_open ? aiTeacherInfo : null
    } catch (e) {
      console.log(e)
    }
  }
  async fetch() {
    this._LoadingAsyncTask(async () => {
      try {
        await this.fetchAiTeacherInfo()
        this.aiTeacherConfig = await getAiTeacherConfig()
        await teacherStore.loadTeacher()
        this.isUnderApp = await AppUtil.isUnderApp()
        const teacherStoreName = (teacherStore?.teacher?.teacher_name || '').trim()
        this.aiParams.curAiInputTeacherName = this.aiTeacherInfo?.name || teacherStoreName
        // 如果有配置形象
        if (this.aiTeacherConfig?.images && this.aiTeacherConfig.images.length) {
          this.curAiSelectTeacherProfile =
            this.aiTeacherConfig.images.find((i) => i.id === this.aiTeacherInfo?.image_id || '') ||
            this.aiTeacherConfig.images[0]
          this.aiTeacherAudioPlayer = new AiTeacherAudioPlayer(this.aiTeacherConfig.images || [])
        }
        // 如果是新开通，首次进入页面，播放语音
        if (this.type === 'add') {
          if (this.isUnderApp) {
            AppUtil.callGetAppVersion()
          }
          this.playAiTeacherVoice()
        }
        // await this.fetchActivityInfo()
      } catch (e) {
        console.log(e)
      }
    })
  }

  handleAiTeacherSelect(selected: IAiTeacherProfile) {
    this.curAiSelectTeacherProfile = selected
    this.playAiTeacherVoice()
  }
  handleAiTeacherName(name: string) {
    this.aiParams.curAiInputTeacherName = name
  }
  handleAiTeacherCancel() {
    if (this.type === 'add') {
      this.$router.go(-1)
    } else {
      this.isTeacherEditVisible = false
    }
    this.aiTeacherAudioPlayer?.pause()
  }
  handleback() {
    this.aiTeacherAudioPlayer?.pause()
    if (this.type === 'edit' && this.isTeacherEditVisible) {
      this.isTeacherEditVisible = false
    } else {
      this.$router.go(-1)
    }
  }
  async handleAiTeacherSubmit() {
    this.fetchAiTeacherInfo()
    this.aiTeacherAudioPlayer?.pause()
    this.isTeacherEditVisible = false
    this.$router.replace({ query: { type: 'edit' } })
  }
  playAiTeacherVoice() {
    if (this.curAiSelectTeacherProfile?.id) {
      this.aiTeacherAudioPlayer?.play(
        this.curAiSelectTeacherProfile?.id || '',
        (cur_voice) => {
          this.aiParams.curAiTeacherVoiceText = cur_voice
        },
        1500
      )
    }
  }
  handleSettingClick() {
    this.isTeacherEditVisible = true
    this.playAiTeacherVoice()
  }
  handleAiTeacherDelete() {
    this.isCloseTipVisible = true
  }
  async handleDelConfirmSubmit() {
    try {
      await switchAiTeacher(false)
      this.isCloseTipVisible = false
      this.aiTeacherAudioPlayer?.pause()
      this.$router.go(-1)
    } catch (e) {
      this.toast('操作失败，请重试')
      console.log(e)
    }
  }
}
</script>

<style lang="less">
.my-ai-teacher-container {
  height: 100%;
  box-sizing: border-box;
  padding-top: 52px;
  .ai-teacher-info {
    height: 100%;
    width: 100%;
    background: top / cover url('./assets/back@2x.png') no-repeat;
    .setting {
      display: flex;
      justify-content: flex-end;
      padding: 18px;
      > img {
        display: block;
        width: 32px;
      }
    }
    .info {
      margin-top: 12px;
      .ava {
        margin: 0 auto;
        width: 264px;
        height: 264px;
        border-radius: 50%;
        border: 4px solid #ffffff;
        > img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          display: block;
          object-fit: cover;
        }
      }
      .name {
        margin-top: 20px;
        font-size: 22px;
        font-weight: 600;
        line-height: 30.8px;
        text-align: center;
        color: #fff;
      }
    }
  }
  .carousel {
    margin-top: 52px;
  }
}
</style>
